module.exports = __webpack_public_path__ + "static/media/climate_water_3_hydroelectricityFlowAlteration.4b20fba2.jpg";